import {createFormActionTypes} from "../../../../shared/ts/helpers/create_form_action_types";
import {createFormActions} from "../../../../shared/ts/helpers/create_form_actions";

const ASSIGN_FLOOR_FORM = "offer-building/ASSIGN_FLOOR_FORM";
export const assignFloorFormTypes = createFormActionTypes(ASSIGN_FLOOR_FORM);
export const assignFloorFormActions = createFormActions(assignFloorFormTypes);
